import background from '../../../../assets/ai/background.svg';
import send from '../../../../assets/ai/send.svg';
import deleteIcon from '../../../../assets/ai/delete.svg';
import upload from '../../../../assets/ai/upload.svg';
import download from '../../../../assets/ai/download.svg';
import plus from '../../../../assets/ai/plus.svg';
export const aiAssets = Object.freeze({
  background,
  send,
  deleteIcon,
  upload,
  download,
  plus,
});
